module.exports = __webpack_public_path__ + "media/images/ai_voice_samples/neil-d6f68de86d213a3286b8b22bfbe5240e.mp3";